import React, { useState } from 'react';
import Axios from '../../Components/Axios/Axios';
import { useHistory } from 'react-router-dom';
import { Grid, Paper, TextField, InputAdornment, Button } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import logo from '../../Images/logo_name.png';
import icon_success from '../../Images/Icons/success.png';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

function Reset() {
    // For History
    const history = useHistory();

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 600, margin: '10px auto' }

    // For Get Value from Username
    const [forUsername, setforUsername] = useState("");
    const userName = (e) => {
        const result = e.target.value
        setforUsername(result)
    }

    // For Get Value from OTP password
    const [forOtpPasswd, setforOtpPasswd] = useState("");
    const otpPass = (e) => {
        const result = e.target.value
        setforOtpPasswd(result)
    }

    // For Get New Password and Confirm Password
    const [forNewPasswd, setforNewPasswd] = useState("");
    const [forConPasswd, setforConPasswd] = useState("");
    const newPass = (e) => {
        const result = e.target.value
        setforNewPasswd(result)
    }
    const conPass = (e) => {
        const result = e.target.value
        setforConPasswd(result)
    }

    // For Send OTP Button
    const [showTel, setShowTel] = useState("");

    // For Hidden Any Tab
    const [showTabReq, setShowTabReq] = useState(true);
    const [showTabOTP, setShowTabOTP] = useState(false);
    const [showTabChange, setShowTabChange] = useState(false);

    // For Hidden Any Alert
    const [alertReq, setAlertReq] = useState(false);
    const [alertOtp, setAlertOtp] = useState(false);
    const [alertConfirm, setAlertConfirm] = useState(false);

    // For Alert Success
    const [openSuccess, setOpenSuccess] = useState(false);

    // For Hide/Open Eye Password
    const [passwordEye, setPasswordEye] = useState(false);
    const eyeClick = () => {
        setPasswordEye(!passwordEye);
    }

    // For Send_OTP
    const Send_OTP = async () => {
        if (forUsername != "") {
            await Axios.post('/Authenticate/Send_OTP', {
                username: forUsername
            })
                .then(function (response) {
                    console.log(response.data)
                    if (response.data.result_code == '200') {
                        setShowTel(response.data.emp_tel)
                        setShowTabReq(false)
                        setShowTabOTP(true)
                        setAlertReq(false)
                    } else {
                        setAlertReq(true)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
        }
    }

    // For Check OTP
    const Check_OTP = async () => {
        if (forUsername != "" && forOtpPasswd != "") {
            await Axios.post('/Authenticate/Check/Password', {
                username: forUsername,
                password: forOtpPasswd
            })
                .then(function (response) {
                    console.log(response.data)
                    if (response.data.result_code == '200') {
                        setShowTabChange(true)
                        setShowTabOTP(false)
                        setAlertOtp(false)
                    } else {
                        setAlertOtp(true)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
        }
    }

    // For Change Password
    const Change_Password = async () => {
        if (forNewPasswd != "" && forConPasswd != "") {
            if (forNewPasswd != forConPasswd) {
                setAlertConfirm(true)
            } else {
                setAlertConfirm(false)
                await Axios.post('/Authenticate/Change/Password', {
                    username: forUsername,
                    new_password: forNewPasswd
                })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.result_code == '200') {
                            setOpenSuccess(true)
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    }

    // For Change Path to Login
    const goLogin = () => {
        history.push('/');
    }

    return (
        <>
            <div className='login_bg'>
                <Grid className='login_con'>
                    <Paper elevation={10} style={paperStyle} className='login_paper'>
                        <Grid container className='login_grid_logo'>
                            <img src={logo} width='300' />
                        </Grid>

                        <div className='login_welcome'>ປ່ຽນລະຫັດຜ່ານຂອງທ່ານ</div>

                        <Grid container>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <hr className='login_line_hr' />
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>

                        {showTabReq == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <span className='login_label'>ລະຫັດພະນັກງານ:</span>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <PersonIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        onChange={userName}
                                    />
                                </Grid>
                            </Grid>
                        </> : <></>}

                        {alertReq == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Stack sx={{ width: '100%' }} spacing={2}>
                                        <Alert variant="outlined" severity="warning">
                                            <span className='login_alert'>ລະຫັດພະນັກງານນີ້ ບໍ່ມີໃນລະບົບ !</span>
                                        </Alert>
                                    </Stack>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {showTabOTP == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <span className='login_label'>OTP ຂອງທ່ານໄດ້ສົ່ງໄປທີ: ({showTel})</span>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <span className='login_label'>ປ້ອນລະຫັດ OTP:</span>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        type='number'
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <KeyIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        onChange={otpPass}
                                    />
                                </Grid>
                            </Grid>
                        </> : <></>}

                        {alertOtp == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Stack sx={{ width: '100%' }} spacing={2}>
                                        <Alert variant="outlined" severity="warning">
                                            <span className='login_alert'>ລະຫັດ OTP ຂອງທ່ານບໍ່ຖືກຕ້ອງ !</span>
                                        </Alert>
                                    </Stack>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {showTabChange == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <span className='login_label'>ລະຫັດຜ່ານໃຫມ່:</span>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id='input-with-icon-textfield'
                                        type={(passwordEye === false) ? 'password' : 'text'}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <KeyIcon />
                                                </InputAdornment>
                                            ),

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {(passwordEye === false) ? <VisibilityOffIcon onClick={eyeClick} /> : <RemoveRedEyeIcon onClick={eyeClick} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                        size='small'
                                        variant="outlined"
                                        fullWidth
                                        onChange={newPass}
                                    />
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <span className='login_label'>ຢືນຢັນລະຫັດຜ່ານ:</span>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id='input-with-icon-textfield'
                                        type={(passwordEye === false) ? 'password' : 'text'}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <KeyIcon />
                                                </InputAdornment>
                                            ),

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {(passwordEye === false) ? <VisibilityOffIcon onClick={eyeClick} /> : <RemoveRedEyeIcon onClick={eyeClick} />}
                                                </InputAdornment>
                                            ),
                                        }}
                                        size='small'
                                        variant="outlined"
                                        fullWidth
                                        onChange={conPass}
                                    />
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {alertConfirm == true ? <>
                            <Grid container className='login_tab_label'>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Stack sx={{ width: '100%' }} spacing={2}>
                                        <Alert variant="outlined" severity="warning">
                                            <span className='login_alert'>ລະຫັດຜ່ານທັງ 2 ບໍ່ກົງກັນ !</span>
                                        </Alert>
                                    </Stack>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {showTabReq == true ? <>
                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Button className='login_submit_button' fullWidth variant="outlined" onClick={Send_OTP}>ຂໍລະຫັດ OTP</Button>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {showTabOTP == true ? <>
                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Button className='login_submit_button' fullWidth variant="outlined" onClick={Check_OTP}>ຢືນຢັນ</Button>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        {showTabChange == true ? <>
                            <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Button className='login_submit_button' fullWidth variant="outlined" onClick={Change_Password}>ປ່ຽນລະຫັດຜ່ານ</Button>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                        </> : <></>}

                        <Grid container className='login_tab_reset'>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <span className='login_reset'>ຍົກເລີກການປ່ຽນລະຫັດ <a href='/' className='login_reset_link'>ກັບຄືນໄປໜ້າລ໋ອກອິນ</a></span>
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </div>

            <Dialog
                fullWidth={true}
                open={openSuccess}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className='login_dialog_title'>
                        <img src={icon_success} width={120} />
                    </div>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div className='login_dialog_content'>
                            ການແກ້ໄຂລະຫັດຜ່ານຂອງທ່ານ ສໍາເລັດແລ້ວ !
                        </div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Grid container>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}>
                            <div className='login_dialog_action'>
                                <Button type='submit' variant='contained' className='login_dialog_button' onClick={goLogin}>
                                    OK
                                </Button>
                            </div>
                        </Grid>
                        <Grid item xs={4}></Grid>
                    </Grid>
                </DialogActions>
            </Dialog >
        </>
    )
}

export default Reset